<div id="commentHeader">
  <h3 class="headline-small">{{ 'comments.title' | translate }}</h3>
  <button mat-icon-button (click)="close()">
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </button>
</div>

@if (createCommentLink()) {
  <div id="commentInputContainer" [class.expanded]="isInputExpanded()" [class.disabled]="saving()">
    <div id="inputRow">
      @if (!isInputExpanded()) {
        <mat-icon class="material-symbols-outlined" id="placeholderIcon">edit_note</mat-icon>
      }
      <textarea
        [ngModel]="commentText()"
        (ngModelChange)="commentText.set($event)"
        [maxlength]="maxLength"
        [placeholder]="(isInputExpanded() ? 'comments.expandedPlaceholder' : 'comments.placeholder') | translate"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [rows]="isInputExpanded() ? 4 : 1"
        [disabled]="saving()"
      ></textarea>
    </div>
  </div>
  @if (isInputExpanded()) {
    <span id="charCount" class="body-small">{{ commentText().length }}/{{ maxLength }}</span>
    <div id="commentActions">
      <button mat-button (click)="onCancel()" [disabled]="saving()">{{ 'comments.cancel' | translate }}</button>
      <button mat-flat-button color="primary" (click)="onSave()"
              [disabled]="commentText().trim().length === 0 || saving()">{{ 'comments.save' | translate }}
      </button>
    </div>
  }
}

<div id="commentSeparator"></div>

<div id="commentListScroller">
<div id="commentList">
  @if (loading()) {
    @for (i of [1, 2]; track i) {
      <div class="commentItem skeleton">
        <div class="commentAvatar skeletonPulse"></div>
        <div class="commentBody">
          <div class="commentItemHeader">
            <span class="skeletonLine skeletonPulse" style="width: 40%"></span>
            <span class="skeletonLine skeletonPulse" style="width: 25%"></span>
          </div>
          <div class="skeletonLine skeletonPulse" style="width: 90%; margin-top: 8px"></div>
          <div class="skeletonLine skeletonPulse" style="width: 60%; margin-top: 6px"></div>
        </div>
      </div>
    }
  } @else if (loadError()) {
    <div id="loadErrorState">
      <mat-icon class="material-symbols-outlined" id="loadErrorStateIcon">error_outline</mat-icon>
      <p class="body-medium">{{ 'comments.loadError.message' | translate }}</p>
      <button mat-button (click)="retryLoad()">{{ 'comments.loadError.retry' | translate }}</button>
    </div>
  } @else if (comments().length === 0) {
    <div id="emptyState">
      <mat-icon class="material-symbols-outlined" id="emptyStateIcon">chat_bubble_outline</mat-icon>
      <p class="body-medium">{{ 'comments.emptyState' | translate }}</p>
    </div>
  } @else {
    @for (comment of comments(); track comment.identification) {
      <div class="commentItem">
        <div class="commentBody">
          <div class="commentItemHeader">
            <div class="commentAuthorInfo">
              <span class="label-medium">{{ comment.authorName?.trim() || ('comments.unknownAuthor' | translate) }}</span>
              <span class="body-small commentDate">
                {{ comment.createdAt | date:'dd.MM.yyyy, HH:mm' }}
                @if (comment.updatedAt) {
                  <span class="commentEditedLabel"
                        [matTooltip]="'comments.editedTooltip' | translate:{ date: (comment.updatedAt | date:'dd.MM.yyyy, HH:mm') }">
                    {{ 'comments.edited' | translate }}
                  </span>
                }
              </span>
            </div>
            @if (comment._links.getLink('update') || comment._links.getLink('delete')) {
              <button mat-icon-button [matMenuTriggerFor]="commentMenu" class="commentMenuButton">
                <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
              </button>
              <mat-menu #commentMenu="matMenu">
                @if (comment._links.getLink('update')) {
                  <button mat-menu-item (click)="onEdit(comment)">
                    <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    <span>{{ 'comments.edit' | translate }}</span>
                  </button>
                }
                @if (comment._links.getLink('delete')) {
                  <button mat-menu-item (click)="onDelete(comment)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    <span>{{ 'comments.delete' | translate }}</span>
                  </button>
                }
              </mat-menu>
            }
          </div>
          @if (editingCommentId() === comment.identification) {
            <div class="commentEditContainer" [class.disabled]="savingEdit()">
              <textarea
                class="commentEditTextarea"
                [ngModel]="editText()"
                (ngModelChange)="editText.set($event)"
                [maxlength]="maxLength"
                [disabled]="savingEdit()"
                rows="4"
              ></textarea>
            </div>
            <span class="commentEditCharCount body-small">{{ editText().length }}/{{ maxLength }}</span>
            <div class="commentEditActions">
              <button mat-button (click)="onCancelEdit()" [disabled]="savingEdit()">{{ 'comments.cancel' | translate }}</button>
              <button mat-flat-button color="primary" (click)="onSaveEdit(comment)"
                      [disabled]="editText().trim().length === 0 || savingEdit()">{{ 'comments.save' | translate }}
              </button>
            </div>
          } @else {
            <p class="body-medium commentContent" #contentEl
               [class.clamped]="!expandedComments.has(comment.identification)">{{ comment.content }}</p>
            @if (contentEl.scrollHeight > contentEl.clientHeight || expandedComments.has(comment.identification)) {
              <button class="showMoreButton body-small" (click)="toggleExpand(comment.identification)">
                {{ (expandedComments.has(comment.identification) ? 'comments.showLess' : 'comments.showMore') | translate }}
              </button>
            }
          }
        </div>
      </div>
    }
  }
</div>
</div>
